<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>到期日报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item label="客户类型">
                                <el-select v-model="searchform.type" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="新客" value="1"></el-option>
                                    <el-option label="老客" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="渠道">
                                <el-select size="small" v-model="searchform.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                    <el-option v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="App">
                                <el-select size="small" v-model="searchform.app" multiple @change="onAppChange" :placeholder="$t('qxz')" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="item in appChannelList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="子产品">
                                <el-select size="small" v-model="searchform.platform" :disabled="subProductChannelList.length === 0" :placeholder="$t('qxz')" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option
                                        v-for="item in subProductChannelList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="结清次数>=">
                                <el-input-number v-model="searchform.number" :min="0" size="small" ></el-input-number>
                            </el-form-item>
                            <el-form-item label="到期日时间">
                                <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="expire_date" label="到期日"></el-table-column>
                        <el-table-column prop="expire_cnt" label="到期cnt"></el-table-column>
                        <el-table-column prop="rate_prepay_2d_incl_extend" label="累计提前2天还款cnt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="h2_repay_rate" label="H2还款(cnt)率"></el-table-column>
                        <el-table-column prop="rate_prepay_1d_incl_extend" label="累计提前1天还款cnt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="h1_repay_rate" label="H1还款(cnt)率"></el-table-column>
                        <el-table-column prop="rate_same_day_incl_extend" label="累计还款日当天还款(cnt)率(含展期和分期)"></el-table-column>
                        <el-table-column prop="s0_repay_rate" label="S0还款(cnt)率"></el-table-column>
                        <el-table-column prop="s1_repay_rate" label="S1还款(cnt)率"></el-table-column>
                        <el-table-column prop="s2_repay_rate" label="S2还款(cnt)率"></el-table-column>
                        <el-table-column prop="urge_cnt" label="入催cnt"></el-table-column>
                        <el-table-column prop="urge_amt_rate_incl_extend" label="广义入催amt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="urge_cnt_rate_incl_extend" label="广义入催cnt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="narrow_urge_amt_rate" label="狭义入催amt率(不含展期和分期)"></el-table-column>
                        <el-table-column prop="narrow_urge_cnt_rate" label="狭义入催cnt率(不含展期和分期)"></el-table-column>
                        <el-table-column prop="paid_cnt_incl_extend" label="当前已还cnt(含展期和分期)"></el-table-column>
                        <el-table-column prop="late_amt_rate_incl_extend" label="广义在逾amt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="late_cnt_rate_incl_extend" label="广义在逾cnt率(含展期和分期)"></el-table-column>
                        <el-table-column prop="narrow_late_amt_rate" label="狭义在逾amt率(不含展期和分期)"></el-table-column>
                        <el-table-column prop="narrow_late_cnt_rate" label="狭义在逾cnt率(不含展期和分期)"></el-table-column>
                        <el-table-column prop="extend_cnt" label="展期cnt"></el-table-column>
                        <el-table-column prop="extend_rate" label="展期率"></el-table-column>
                        <el-table-column prop="instal_cnt" label="分期cnt"></el-table-column>
                        <el-table-column prop="instal_rate" label="分期率"></el-table-column>
                        <el-table-column prop="rate_1d_late" label="1日在逾率"></el-table-column>
                        <el-table-column prop="rate_2d_late" label="2日在逾率"></el-table-column>
                        <el-table-column prop="rate_3d_late" label="3日在逾率"></el-table-column>
                        <el-table-column prop="rate_5d_late" label="5日在逾率"></el-table-column>
                        <el-table-column prop="rate_7d_late" label="7日在逾率"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: null,
                    app:null,
                    platform:null,
                    number:"",
                },
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:null,
                typeList: [],
                appChannelList: [],
                subProductChannelList: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList()
            this.getAppChannel()
        },
        methods: {
            onAppChange(val) {
                this.searchform.platform=null
                if (val === null) {
                    this.subProductChannelList=[]
                } else {
                    this.getSubProductChannel();
                }
            },
            getNowTime() {
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },

            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getAppChannel() {
                _api.get(apiurl.appChannel, {
                }).then(res => {
                    this.appChannelList = res.data
                })
            },
            getSubProductChannel() {
                _api.get(apiurl.subProductChannel, {
                    app: this.searchform.app
                }).then(res => {
                    this.subProductChannelList = res.data
                })
            },
            getList() {
                this.loading = true
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }

                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }

                const type1 = null; 
                if (this.searchform.app != null) {
                    this.type1 = this.searchform.app.join(",")
                }

                _api.get(apiurl.dueDate, {
                    type: this.type,
                    createTime: this.value1,
                    app: this.type1,
                    platform: this.searchform.platform,
                    number: this.searchform.number,
                    customerType: this.searchform.type,
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>